import { Col } from "reactstrap";
import { ExtendedBackgroundColor } from "../../../../Constant";
import { H4 } from "../../../../AbstractElements";

export const ExtendedBackgroundColors = () => {
  return (
    <Col xl="4" sm="12">
      <div className="border-wrapper h-100 border">
        <H4 className="mb-3">{ExtendedBackgroundColor}</H4>
        <div className="d-flex align-items-center mb-2 gap-2">
          <div className={`helper-box light-card `}> </div>.light-card
        </div>
          <div className="d-flex align-items-center mb-2 gap-2">
            <div className="helper-box light-background border"> </div>.light-background
          </div>
      </div>
    </Col>
  );
};
